import React, { FC } from 'react'
import { accordionData } from '@mortgage-pos/ui/data/accordionData'
import Accordion from './Accordion'

const PricingInfoAccordion: FC = () => {
  const [openIndex, setOpenIndex] = React.useState(0)

  const changeOpenIndex = (index) => {
    setOpenIndex(index)
  }

  return (
    <div className="pricing-accordion-container">
      <h2 className="pricing-label">
        Learn more
        <span className="pricing-label__mobile-container">about pricing</span>
      </h2>
      <section className="pricing-section">
        <div className="pricing-section__text-container">
          <Accordion
            openIndex={openIndex}
            onChange={changeOpenIndex}
            items={accordionData.pricingInfo}
          />
        </div>
      </section>
    </div>
  )
}

export default PricingInfoAccordion
